import { render, staticRenderFns } from "./RecurringRemarkDetail.vue?vue&type=template&id=1a749a5e&scoped=true"
import script from "./RecurringRemarkDetail.vue?vue&type=script&lang=js"
export * from "./RecurringRemarkDetail.vue?vue&type=script&lang=js"
import style0 from "./RecurringRemarkDetail.vue?vue&type=style&index=0&id=1a749a5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a749a5e",
  null
  
)

export default component.exports